import {
    useGetLoyaltyConfigQuery,
    useUpdateLoyaltyConfigMutation,
} from '@/services/innovorder/modules/modules.endpoints';
import { useParams } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { UpdateZerosixConfigForm } from './ZerosixConfigUpdateForm';
import { LoyaltyProvider } from '../../Loyalty/loyalty.type';
const useUpdateZerosixConfig = () => {
    const { restaurantId } = useParams<{ restaurantId: string }>();
    const [updateZerosixConfig, { isLoading: isUpdating, isSuccess: isUpdateSuccess }] =
        useUpdateLoyaltyConfigMutation();
    const { data: loyaltyConfig } = useGetLoyaltyConfigQuery({
        restaurantId: Number(restaurantId),
    });

    const {
        control,
        handleSubmit,
        formState: { isDirty, isValid },
    } = useForm<UpdateZerosixConfigForm>({
        mode: 'all',
    });

    const onSubmit = (data: UpdateZerosixConfigForm) => {
        updateZerosixConfig({
            restaurantId: Number(restaurantId),
            useCasualTone: data.useCasualTone,
            memberIdentifier: data.memberIdentifier,
            provider: LoyaltyProvider.ZEROSIX,
            authenticationMethods: data.authenticationMethods,
            registerMethods: data.registerMethods,
            features: data.features,
        });
    };

    return { control, handleSubmit, onSubmit, isUpdating, isDirty, isUpdateSuccess, isValid };
};

export default useUpdateZerosixConfig;
